import { WorkOrder } from "@/services/backend/rlt/work-orders/types/work-order";
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/shared/components/ui/dialog";
import { Button } from "@/shared/components/ui/button";
import t from "@/lang/lang";
import { RTKQueryErrorAlert } from "@/shared/components/errors/rtk-query-error-alert";
import { FulfillmentState } from "@/services/backend/relationships/types/fulfillment";
import { useEffect, useState } from "react";
import { RefreshCw } from "lucide-react";
import { useRltWorkOrderUpdateStateMutation } from "@/services/backend/rlt/work-orders/api/work-order-api";

export function CompleteExecutionDialog({
  workOrder,
}: {
  workOrder: WorkOrder;
}) {
  const [open, setOpen] = useState(false);
  const [patch, { isLoading, error, isSuccess, reset }] =
    useRltWorkOrderUpdateStateMutation();

  useEffect(() => {
    if (isSuccess) {
      setOpen(false);
      reset();
    }
  }, [isSuccess, reset]);

  const doForward = (state: FulfillmentState) => () => {
    if (isLoading) return;

    patch({
      id: workOrder.id,
      state,
    });
  };

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <Button>{t("Ausführung beenden")}</Button>
      </DialogTrigger>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>{t("Ausführung beenden?")}</DialogTitle>
          <DialogDescription>
            {t(
              'Der Arbeitsschein wird als in "Ausgeführt" oder "Teilweise Ausgeführt" markiert. Der Arbeitsschein wird in die Nachbereitung übergeben.',
            )}
          </DialogDescription>
        </DialogHeader>
        <RTKQueryErrorAlert error={error} ignoreValidationError={false} />
        <DialogFooter>
          <DialogClose asChild>
            <Button variant="outline">{t("Abbrechen")}</Button>
          </DialogClose>
          <Button
            onClick={doForward(FulfillmentState.PartiallyExecuted)}
            disabled={isLoading}
          >
            {isLoading && <RefreshCw className="size-4 animate-spin" />}
            {t("Teilweise ausgeführt")}
          </Button>
          <Button
            onClick={doForward(FulfillmentState.Executed)}
            disabled={isLoading}
          >
            {isLoading && <RefreshCw className="size-4 animate-spin" />}
            {t("Vollständig ausgeführt")}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
